/*
  assets/gtender-referral-share.js — GTENDER-IOS-REFERRAL-SHARE-02
  Owner: GTender referral-share payload + native Web Share handoff + iOS-style fallback sheet.
  Boundary: share GTender deep links only; never replaces tender data, bookmark, auth, search or official-source ownership.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-gtender-public-entry]';
  var SHARE_SELECTOR =
    '[data-gtender-share], [data-gtender-detail-share], [data-gtender-star-share]';
  var TENDER_ID_RE = /^[A-Za-z0-9._:-]{3,240}$/;
  var VERSION = '2026-10-05-ios-referral-share-02';
  var activeSheet = null;
  var returnFocus = null;

  function clean(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isZh(root) {
    var raw =
      clean(root && root.getAttribute('data-locale')) ||
      clean(document.documentElement && document.documentElement.lang) ||
      'en';
    return /^zh/i.test(raw);
  }

  function copy(root) {
    return isZh(root)
      ? {
          nativeTitle: 'GTender｜招標搜尋',
          intro: '這個招標給你參考：',
          outro: '在 GTender 查看詳情及更多最新招標。',
          sheetTitle: '分享這個招標',
          siteLine: '香港招標搜尋',
          copyAction: '複製分享內容',
          copied: '已複製',
          openAction: '在 GTender 開啟',
          cancel: '取消',
          fallbackTitle: 'GTender 招標',
        }
      : {
          nativeTitle: 'GTender — Tender Search',
          intro: 'Sharing this tender with you:',
          outro: 'View it on GTender and browse more recent tenders.',
          sheetTitle: 'Share this tender',
          siteLine: 'Hong Kong Tender Search',
          copyAction: 'Copy Share Message',
          copied: 'Copied',
          openAction: 'Open in GTender',
          cancel: 'Cancel',
          fallbackTitle: 'GTender tender',
        };
  }

  function tenderUrl(id) {
    var key = clean(id);
    if (!TENDER_ID_RE.test(key)) return '';
    try {
      var url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set('tender', key);
      return url.toString();
    } catch (_error) {
      return '';
    }
  }

  function titleFromTarget(root, target) {
    var detail = target.closest && target.closest('[data-gtender-public-detail]');
    if (detail) {
      var detailTitle = detail.querySelector('[data-gtender-detail-subject]');
      if (detailTitle && clean(detailTitle.textContent)) return clean(detailTitle.textContent);
    }

    var card = target.closest && target.closest('article, .gtender-partner-entry__card');
    if (card) {
      var cardTitle = card.querySelector('.gtender-card__title, [data-gtender-star-title], h3, h4');
      if (cardTitle && clean(cardTitle.textContent)) return clean(cardTitle.textContent);
    }

    var rootDetail =
      root &&
      root.querySelector(
        '[data-gtender-public-detail][data-gtender-detail-visible="true"] [data-gtender-detail-subject]'
      );
    return rootDetail ? clean(rootDetail.textContent) : '';
  }

  function idFromTarget(root, target) {
    return clean(
      target.getAttribute('data-gtender-share-id') ||
        target.getAttribute('data-gtender-star-share') ||
        (root && root.getAttribute('data-gtender-active-detail-id'))
    );
  }

  function payloadFor(root, title, id) {
    var strings = copy(root);
    var safeTitle = clean(title) || strings.fallbackTitle;
    var url = tenderUrl(id);
    if (!url) return null;
    var text = [strings.intro, '', safeTitle, '', strings.outro].join('\n');
    return {
      title: strings.nativeTitle,
      text: text,
      url: url,
      tenderTitle: safeTitle,
      clipboardText: text + '\n' + url,
    };
  }

  function icon(name, root) {
    const key = name === 'copy' ? 'copy' : 'external-link';
    const template = (root || document).querySelector(
      'template[data-gtender-icon-template="' + key + '"]'
    );
    const source = template && template.content ? template.content.querySelector('svg') : null;
    return source ? source.cloneNode(true).outerHTML : '';
  }

  function ensureStyles() {
    if (document.getElementById('gtender-referral-share-styles')) return;
    var style = document.createElement('style');
    style.id = 'gtender-referral-share-styles';
    style.textContent = [
      '.gtender-referral-share{position:fixed;inset:0;z-index:2147483600;display:grid;align-items:end;justify-items:center;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Arial,sans-serif;}',
      '.gtender-referral-share__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.28);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}',
      '.gtender-referral-share__sheet{position:relative;width:min(calc(100% - 16px),520px);margin:0 8px calc(8px + env(safe-area-inset-bottom,0px));padding:8px;border-radius:24px;background:rgba(242,242,247,.96);box-shadow:0 18px 54px rgba(0,0,0,.22);transform:translateY(calc(100% + 24px));opacity:.92;transition:transform .28s cubic-bezier(.22,.8,.25,1),opacity .2s ease;overflow:hidden;}',
      '.gtender-referral-share[data-open="true"] .gtender-referral-share__sheet{transform:translateY(0);opacity:1;}',
      '.gtender-referral-share__grabber{width:36px;height:5px;margin:2px auto 9px;border-radius:999px;background:rgba(60,60,67,.3);}',
      '.gtender-referral-share__header{padding:0 8px 10px;text-align:center;}',
      '.gtender-referral-share__brand{margin:0 0 3px;color:#007aff;font-size:13px;font-weight:700;letter-spacing:.01em;}',
      '.gtender-referral-share__header h2{margin:0;color:#1c1c1e;font-size:17px;font-weight:700;line-height:1.25;}',
      '.gtender-referral-share__preview{margin:0 0 8px;padding:13px 14px;border-radius:15px;background:#fff;text-align:left;}',
      '.gtender-referral-share__preview strong{display:block;overflow:hidden;color:#1c1c1e;font-size:15px;font-weight:650;line-height:1.35;text-overflow:ellipsis;white-space:nowrap;}',
      '.gtender-referral-share__preview span{display:block;margin-top:4px;color:#6e6e73;font-size:12px;line-height:1.3;}',
      '.gtender-referral-share__actions{overflow:hidden;border-radius:15px;background:#fff;}',
      '.gtender-referral-share__action{display:grid;grid-template-columns:32px minmax(0,1fr);align-items:center;width:100%;min-height:54px;padding:0 15px;border:0;background:transparent;color:#007aff;font:inherit;font-size:16px;text-align:left;cursor:pointer;}',
      '.gtender-referral-share__action+.gtender-referral-share__action{border-top:.5px solid rgba(60,60,67,.2);}',
      '.gtender-referral-share__action svg{justify-self:start;}',
      '.gtender-referral-share__action:focus-visible,.gtender-referral-share__cancel:focus-visible{outline:2px solid #007aff;outline-offset:-3px;}',
      '.gtender-referral-share__cancel{width:100%;min-height:54px;margin-top:8px;border:0;border-radius:15px;background:#fff;color:#007aff;font:inherit;font-size:17px;font-weight:650;cursor:pointer;}',
      '@media (prefers-color-scheme:dark){.gtender-referral-share__sheet{background:rgba(28,28,30,.96)}.gtender-referral-share__grabber{background:rgba(235,235,245,.3)}.gtender-referral-share__header h2,.gtender-referral-share__preview strong{color:#f5f5f7}.gtender-referral-share__preview,.gtender-referral-share__actions,.gtender-referral-share__cancel{background:#2c2c2e}.gtender-referral-share__preview span{color:#aeaeb2}.gtender-referral-share__action+.gtender-referral-share__action{border-top-color:rgba(84,84,88,.65)}}',
      '@media (prefers-reduced-motion:reduce){.gtender-referral-share__sheet{transition:none;transform:none;opacity:1}}',
    ].join('');
    document.head.appendChild(style);
  }

  function closeSheet() {
    if (!activeSheet) return;
    var host = activeSheet;
    activeSheet = null;
    host.removeAttribute('data-open');
    var focusTarget = returnFocus;
    returnFocus = null;
    window.setTimeout(
      function () {
        if (host.parentNode) host.parentNode.removeChild(host);
        if (focusTarget && typeof focusTarget.focus === 'function') {
          try {
            focusTarget.focus({ preventScroll: true });
          } catch (_error) {
            focusTarget.focus();
          }
        }
      },
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220
    );
  }

  function copyToClipboard(text, button, strings) {
    var write =
      navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(text)
        : Promise.reject(new Error('clipboard_unavailable'));
    return write
      .then(function () {
        var label = button.querySelector('span');
        if (label) label.textContent = strings.copied;
        window.setTimeout(closeSheet, 450);
      })
      .catch(function () {
        var area = document.createElement('textarea');
        area.value = text;
        area.readOnly = true;
        area.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(area);
        area.focus();
        area.select();
        try {
          document.execCommand('copy');
        } catch (_error) {}
        area.remove();
        var label = button.querySelector('span');
        if (label) label.textContent = strings.copied;
        window.setTimeout(closeSheet, 450);
      });
  }

  function showFallback(root, payload, sourceButton) {
    ensureStyles();
    closeSheet();
    var strings = copy(root);
    returnFocus = sourceButton;

    var host = document.createElement('div');
    host.className = 'gtender-referral-share';
    host.setAttribute('data-gtender-referral-share-sheet', '');
    host.setAttribute('role', 'dialog');
    host.setAttribute('aria-modal', 'true');
    host.setAttribute('aria-labelledby', 'GTenderReferralShareTitle');

    var backdrop = document.createElement('div');
    backdrop.className = 'gtender-referral-share__backdrop';
    backdrop.setAttribute('aria-hidden', 'true');

    var sheet = document.createElement('div');
    sheet.className = 'gtender-referral-share__sheet';
    sheet.innerHTML =
      '<div class="gtender-referral-share__grabber" aria-hidden="true"></div>' +
      '<div class="gtender-referral-share__header"><p class="gtender-referral-share__brand">GTender</p><h2 id="GTenderReferralShareTitle"></h2></div>' +
      '<div class="gtender-referral-share__preview"><strong></strong><span></span></div>' +
      '<div class="gtender-referral-share__actions"></div>';
    sheet.querySelector('h2').textContent = strings.sheetTitle;
    sheet.querySelector('.gtender-referral-share__preview strong').textContent =
      payload.tenderTitle;
    sheet.querySelector('.gtender-referral-share__preview span').textContent =
      strings.siteLine + ' · ' + new URL(payload.url).host;

    var actions = sheet.querySelector('.gtender-referral-share__actions');
    var copyButton = document.createElement('button');
    copyButton.type = 'button';
    copyButton.className = 'gtender-referral-share__action';
    copyButton.innerHTML = icon('copy', root) + '<span></span>';
    copyButton.querySelector('span').textContent = strings.copyAction;
    copyButton.addEventListener('click', function () {
      void copyToClipboard(payload.clipboardText, copyButton, strings);
    });

    var openButton = document.createElement('button');
    openButton.type = 'button';
    openButton.className = 'gtender-referral-share__action';
    openButton.innerHTML = icon('open', root) + '<span></span>';
    openButton.querySelector('span').textContent = strings.openAction;
    openButton.addEventListener('click', function () {
      window.location.assign(payload.url);
    });

    actions.appendChild(copyButton);
    actions.appendChild(openButton);

    var cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'gtender-referral-share__cancel';
    cancel.textContent = strings.cancel;
    cancel.addEventListener('click', closeSheet);
    backdrop.addEventListener('click', closeSheet);

    sheet.appendChild(cancel);
    host.appendChild(backdrop);
    host.appendChild(sheet);
    document.body.appendChild(host);
    activeSheet = host;

    host.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSheet();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(host.querySelectorAll('button:not([disabled])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    requestAnimationFrame(function () {
      host.setAttribute('data-open', 'true');
      copyButton.focus();
    });
  }

  async function shareReferral(root, target, payload) {
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title: payload.title, text: payload.text, url: payload.url });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
    showFallback(root, payload, target);
  }

  function onShareClick(event) {
    var target = event.target && event.target.closest ? event.target.closest(SHARE_SELECTOR) : null;
    if (!target) return;
    var root = target.closest && target.closest(ROOT_SELECTOR);
    if (!root) root = document.querySelector(ROOT_SELECTOR);
    if (!(root instanceof HTMLElement)) return;

    var id = idFromTarget(root, target);
    var payload = payloadFor(root, titleFromTarget(root, target), id);
    if (!payload) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    void shareReferral(root, target, payload);
  }

  document.addEventListener('click', onShareClick, true);
  window.GTenderReferralShare = Object.freeze({ version: VERSION, buildPayload: payloadFor });
})();
